import * as React from "react"
import { Moment } from 'moment';
import * as moment from 'moment';
import { RentalAdvertPricing } from '../../../types/types'
import { FocusedInputShape } from 'react-dates';
import { IntlProvider } from "react-intl";
import BookingForm from "../../conversation/RebookingForm";
import { ApolloProvider } from "react-apollo";
import { getClient } from "../../../api/graphql";
import { RebookFormQuery, query, variables, RebookFormRoutes } from "../../../api/queries/conversation/rebook_form";
import { ToDictionary } from "../../../api/routes";

type Props = {
  advert_id: number
  conversation_id: number
  arrival_date: Moment
  departure_date: Moment
  max_people_select: number
  max_people: number
  room_id: number
}

type State = {
  pricing: RentalAdvertPricing
  arrival_date: Moment
  departure_date: Moment
  max_people: number
  focusedInput: FocusedInputShape
  button_disabled: boolean
}

class StatefullBookingForm extends React.Component<Props, State> {
  constructor(props : Props, context) {
    super(props, context)
    this.state = {
      pricing: null,
      arrival_date: this.props.arrival_date ? moment(this.props.arrival_date) : null,
      departure_date: this.props.departure_date ? moment(this.props.departure_date) : null,
      max_people: this.props.max_people || 1,
      focusedInput: null,
      button_disabled: false,
    }
  }

  render() {
    return (
      <RebookFormQuery
        query={query()}
        variables={variables(
          this.props.advert_id,
          this.state.arrival_date,
          this.state.departure_date,
          this.state.max_people,
          this.props.room_id,
          this.props.conversation_id
        )}
      >
        {({ error, data}) => {
          if(error) return <div>Something went wrong</div>
          const routes = ToDictionary<RebookFormRoutes>(data.routes)
          return (
            <BookingForm
              pricing={data.rentalAdvert ? data.rentalAdvert.pricing : null}
              focusedInput={this.state.focusedInput}
              onDatesChange={(range) => this.setState({ arrival_date: range.startDate, departure_date: range.endDate })}
              onFocusedInputChange={(fi) =>  this.setState({focusedInput: fi})}
              onMaxPersonsChange={(e) => this.setState({ max_people: e })}
              arrival_date={this.state.arrival_date}
              departure_date={this.state.departure_date}
              advert={data.rentalAdvert}
              max_people={this.state.max_people}
              max_people_select={this.props.max_people_select}
              onSubmit={() => window.location.href = routes.get('new_conversation_booking').url}
              button_disabled={this.state.button_disabled}
              room_id={this.props.room_id}
            />
          )
        }}
      </RebookFormQuery>
    )
  }
}

export default (props: Props) => (
  <IntlProvider locale={window.Gites.locale}>
    <ApolloProvider client={getClient()}>
      <StatefullBookingForm
        {...props}
      />
    </ApolloProvider>
  </IntlProvider>
)
